/*------------------------------------*\
    MODULES
\*------------------------------------*/
import InputSoftLimit from 'input-soft-limit';

/*------------------------------------*\
    CHARACTER COUNT MODULE
\*------------------------------------*/
class CharacterCount {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
		const inputSoftLimitInstance = new InputSoftLimit({
		  submitButton: '.js-feedback-form-submit',
		  inputInvalidClass: 'is-invalid'
		});
        inputSoftLimitInstance.init();
    }
}

export default CharacterCount;